import { Injectable } from '@angular/core';
import {HttpParams} from "@angular/common/http";
import {fade} from "../models/fade";
import {HttpClientService} from "./http-client.service";

@Injectable({
  providedIn: 'root'
})
export class FadeTimesService {

  constructor(private http: HttpClientService) { }
  
  public getFadeTimes() {
    return this.http.get('/fade_times/get');
  }

}
